// TODO: Keep lists like these somewhere centralized as they are needed in multiple places.

export const romanContextWords: string[] = [
  'basis',
  'bein',
  'bosniac',
  'bosniak',
  'brot',
  'carpus',
  'chiari',
  'cmc',
  'costa',
  'costae',
  'cranial',
  'diaphys',
  'dig',
  'digit',
  'digitus',
  'dip',
  'eitlastöð',
  'factor',
  'fazekas',
  'fing', // 'fingur' reprs.
  'garden',
  'harris',
  'hryggjarbil',
  'kóð', // 'kóði' reprs.
  'le fort',
  'lið',
  'liðamót',
  'lifrarlapp',
  'lifrarlöpp',
  'lifrarsegment',
  'mc',
  'meningioma',
  'metacarpal',
  'metacarpus',
  'metatars',
  'miðphalanx',
  'modic',
  'morbus köhler',
  'mt',
  'mtp',
  'mv',
  'neer',
  'phalang',
  'phalanx',
  'phalanx proximalis',
  'pip',
  'rif',
  'salter',
  'schatzker',
  'segment',
  'sh',
  'svæð', // 'svæði' reprs.
  'tá',
  'týp',
  'type',
  'tæ', // 'tær' reprs.
];
